import { confluenceLocalStorageInstance } from '@confluence/storage-manager/entry-points/storageInstance';
import { PERSISTED_KEYS_ON_SERVER } from '@confluence/storage-manager/entry-points/LocalStorageKeys';
import { useRenderServerPlaceholder } from '@confluence/ssr-utilities/entry-points/useRenderServerPlaceholder';
import { expVal } from '@confluence/feature-experiments';

export const DEFAULT_SIDEBAR_WIDTH = 320;

export const useSideNavInitialState = () => {
	const renderServerPlaceholder = useRenderServerPlaceholder();
	const shouldForceExpand = false;

	const persistedCollapseState =
		confluenceLocalStorageInstance.getItem(
			PERSISTED_KEYS_ON_SERVER.PERSISTED_LEFT_SIDEBAR_COLLAPSED,
		) ?? 'expanded';
	let persistedWidth = parseInt(
		confluenceLocalStorageInstance.getItem(
			PERSISTED_KEYS_ON_SERVER.PERSISTED_LEFT_SIDEBAR_WIDTH, //can return null does not handle string
		) || DEFAULT_SIDEBAR_WIDTH,
		10,
	);

	if (Number.isNaN(persistedWidth)) {
		//fix for if PERSISTED_LEFT_SIDEBAR_WIDTH is somehow a string
		persistedWidth = DEFAULT_SIDEBAR_WIDTH;
	}

	const initialCollapsedStateServer = persistedCollapseState;
	const initialCollapsedStateClient = shouldForceExpand ? 'expanded' : persistedCollapseState;

	// Server (and hydration) must match SSR output
	const shouldMatchSSR =
		renderServerPlaceholder &&
		expVal('confluence_frontend_hydration_sidebar_button', 'isEnabled', false);

	const initialCollapsedState = shouldMatchSSR
		? initialCollapsedStateServer
		: initialCollapsedStateClient;

	const isWidthTooLarge = persistedWidth > window.innerWidth;
	const clientSidebarWidth = isWidthTooLarge ? DEFAULT_SIDEBAR_WIDTH : persistedWidth;
	const fittedSidebarWidth = shouldMatchSSR ? persistedWidth : clientSidebarWidth;

	return {
		initialCollapsedState,
		initialWidth: fittedSidebarWidth,
		shouldForceExpand,
	};
};
